import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/globals.css'

// Performance monitoring
if (import.meta.env.PROD) {
    // Add performance monitoring here
    console.log('Grupo Médico Empresarial - Production Build')
}

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
)